import { Dispatch } from "redux";
import { setLoading } from "./global";
import WarrantyService from "service/Warranty";
import { showMessage } from "utilities/helper";
import { WarrantyPayloadTypes } from "utilities/types/Warranty";

export const getAllWarranties =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterTenant: number = 1
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_WARRANTY_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_WARRANTY",
      searchValue: search,
    });

    try {
      const data = await WarrantyService.getAllWarranties(
        page,
        search,
        limit,
        filterTenant
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_WARRANTY", value: data.warranties });
      dispatch({
        type: "SET_WARRANTY_PAGE",
        totalPage: !!data.warranties.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.warranties.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_WARRANTY_FILTER_PAGE",
        filterTenantPage: filterTenant,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const updateWarranty =
  (
    warrantyId: string,
    form: WarrantyPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await WarrantyService.updateWarranty(warrantyId, payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().warrantyReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllWarranties(currentPage, searchValue, limitPage, filterTenantPage) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteWarranty =
  (warrantyId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await WarrantyService.deleteWarranty(warrantyId);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().warrantyReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });

      dispatch(getAllWarranties(currentPage, searchValue, limitPage, filterTenantPage) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
